import { type CSSProperties } from 'react';
import { type Rarity, rarityMeta } from '@kon/shared';
import styles from './RarityChip.module.css';

interface RarityChipProps {
  rarity: Rarity;
  size?: 'sm' | 'md';
}

/**
 * Renders a rarity badge. Colors come exclusively from the design tokens
 * (`--rarity-*`), keyed off the shared rarity name — no hardcoded hex.
 */
export function RarityChip({ rarity, size = 'md' }: RarityChipProps) {
  const meta = rarityMeta(rarity);
  const style: CSSProperties = {
    color: `var(--rarity-${rarity})`,
    background: `var(--rarity-${rarity}-soft)`,
    borderColor: `var(--rarity-${rarity}-border)`,
  };
  return (
    <span className={[styles.chip, size === 'sm' ? styles.sm : ''].join(' ')} style={style}>
      <span className={styles.dot} aria-hidden="true" />
      {meta.label}
    </span>
  );
}
